export default __webpack_public_path__ + "static/media/2.1c7d8878.webp";